<ng-select #api
           [labelForId]="type"
           [items]="dropdownList"
           [multiple]= dropdownSettings.multiple
           [closeOnSelect]= dropdownSettings.closeOnSelect
           [clearable]= dropdownSettings.clearable
           [selectOnTab]=dropdownSettings.selectOnTab
           [virtualScroll]=dropdownSettings.virtualScroll
           [searchable]=dropdownSettings.searchable
           [maxSelectedItems]=dropdownSettings.maxSelectedItems
           [clearAllText]=dropdownSettings.clearAllText
           [notFoundText]=dropdownSettings.notFoundText
           bindLabel="name"
           (add)="onAdd($event)"
           (close)="onClose()"
           (remove)="onRemove($event)"
           placeholder={{dropdownSettings.placeholder}}
           [(ngModel)]="selectedItems">

	<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
		<div class="ng-value" *ngIf="items.length > 1" >
			<div class="ng-value-label">{{selectedItems.length}} selected</div>
		</div>
		<div class="ng-value" *ngIf="items.length === 1" >
			<div class="ng-value-label">{{items[0].name}}</div>
		</div>
	</ng-template>

	<ng-template ng-header-tmp>
		<div>
			<input class="dropdown-search-input" type="text" placeholder="Search" (input)="api.filter($event.target.value)" />
		</div>
		<div *ngIf="selectedItems.length > 0" class="unselect-btn-container">
			<button (click)="unselectAll()" class="btn btn-sm btn-secondary">Unselect all</button>
		</div>
		<div class="select-content">
			{{content}}
		</div>
	</ng-template>

	<ng-template ng-option-tmp let-item="item" let-item$="item" let-index="index">
		<div class="checkbox-container">
			<input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/>
			<span class="checkmark"></span><span>{{item.name}}</span>
		</div>
	</ng-template>
</ng-select>
